// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Fondo ── */
#bg {
  background-image: url('fondoemail.jpg');
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
}

.content-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
}

/* ── Tarjeta ── */
.result-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 36px;
  max-width: 460px;
  width: 100%;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);
  animation: slideUp 0.5s ease;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Logo ── */
.logo-wrapper {
  margin: 0 auto 16px;
  width: 72px;
  height: 72px;
}

.logo-img {
  border-radius: 50%;
  border: 3px solid rgba(208, 29, 23, 0.25);
  display: block;
  width: 72px;
  height: 72px;
}

/* ── Spinner ── */
.spinner-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
}

.spinner {
  width: 80px;
  height: 80px;
  animation: rotateSpin 1.4s linear infinite;
}

.spinner-track {
  stroke: #e8e8e8;
}

.spinner-arc {
  stroke: #d01d17;
  stroke-linecap: round;
  stroke-dasharray: 80;
  stroke-dashoffset: 60;
  animation: dashSpin 1.4s ease-in-out infinite;
}

@keyframes rotateSpin {
  to { transform: rotate(360deg); }
}

@keyframes dashSpin {
  0%   { stroke-dashoffset: 120; }
  50%  { stroke-dashoffset: 30; }
  100% { stroke-dashoffset: 120; }
}

/* ── Textos ── */
.title {
  font-size: 1.8rem;
  font-weight: 800;
  color: #391410;
  margin: 0 0 6px;
}

.subtitle {
  font-size: 0.95rem;
  color: #666;
  margin: 0 0 20px;
}

/* ── Divisor ── */
.divider {
  height: 3px;
  background: linear-gradient(90deg, #d01d17, #391410);
  border-radius: 4px;
  margin: 0 auto 20px;
  width: 60px;
}

/* ── Filas de info ── */
.info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.85rem;
  color: #555;
  padding: 9px 12px;
  border-radius: 8px;
  background: #f9f9f9;
  margin-bottom: 8px;
  text-align: left;
}

.info-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}

/* ── Caja de aviso ── */
.advice-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fffbf0;
  border: 1px solid #f5e4a0;
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: 16px;
  text-align: left;
}

.advice-icon {
  font-size: 1.2rem;
  flex-shrink: 0;
}

.advice-box p {
  font-size: 0.85rem;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

/* ── Responsive ── */
@media (max-width: 500px) {
  .result-card { padding: 28px 20px; }
  .title { font-size: 1.5rem; }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/usuarioconfirmacion/usuarioconfirmacion.component.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,uCAA8D;EAC9D,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,sBAAsB,EAAE;EAC/B,OAAO,qBAAqB,EAAE;EAC9B,OAAO,sBAAsB,EAAE;AACjC;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,eAAe,kBAAkB,EAAE;EACnC,SAAS,iBAAiB,EAAE;AAC9B","sourcesContent":["/* ── Fondo ── */\r\n#bg {\r\n  background-image: url('../../../assets/images/fondoemail.jpg');\r\n  min-height: 100vh;\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.55);\r\n}\r\n\r\n.content-wrapper {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 24px 16px;\r\n}\r\n\r\n/* ── Tarjeta ── */\r\n.result-card {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  padding: 40px 36px;\r\n  max-width: 460px;\r\n  width: 100%;\r\n  text-align: center;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);\r\n  animation: slideUp 0.5s ease;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from { opacity: 0; transform: translateY(30px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n/* ── Logo ── */\r\n.logo-wrapper {\r\n  margin: 0 auto 16px;\r\n  width: 72px;\r\n  height: 72px;\r\n}\r\n\r\n.logo-img {\r\n  border-radius: 50%;\r\n  border: 3px solid rgba(208, 29, 23, 0.25);\r\n  display: block;\r\n  width: 72px;\r\n  height: 72px;\r\n}\r\n\r\n/* ── Spinner ── */\r\n.spinner-wrapper {\r\n  width: 80px;\r\n  height: 80px;\r\n  margin: 0 auto 20px;\r\n}\r\n\r\n.spinner {\r\n  width: 80px;\r\n  height: 80px;\r\n  animation: rotateSpin 1.4s linear infinite;\r\n}\r\n\r\n.spinner-track {\r\n  stroke: #e8e8e8;\r\n}\r\n\r\n.spinner-arc {\r\n  stroke: #d01d17;\r\n  stroke-linecap: round;\r\n  stroke-dasharray: 80;\r\n  stroke-dashoffset: 60;\r\n  animation: dashSpin 1.4s ease-in-out infinite;\r\n}\r\n\r\n@keyframes rotateSpin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes dashSpin {\r\n  0%   { stroke-dashoffset: 120; }\r\n  50%  { stroke-dashoffset: 30; }\r\n  100% { stroke-dashoffset: 120; }\r\n}\r\n\r\n/* ── Textos ── */\r\n.title {\r\n  font-size: 1.8rem;\r\n  font-weight: 800;\r\n  color: #391410;\r\n  margin: 0 0 6px;\r\n}\r\n\r\n.subtitle {\r\n  font-size: 0.95rem;\r\n  color: #666;\r\n  margin: 0 0 20px;\r\n}\r\n\r\n/* ── Divisor ── */\r\n.divider {\r\n  height: 3px;\r\n  background: linear-gradient(90deg, #d01d17, #391410);\r\n  border-radius: 4px;\r\n  margin: 0 auto 20px;\r\n  width: 60px;\r\n}\r\n\r\n/* ── Filas de info ── */\r\n.info-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 0.85rem;\r\n  color: #555;\r\n  padding: 9px 12px;\r\n  border-radius: 8px;\r\n  background: #f9f9f9;\r\n  margin-bottom: 8px;\r\n  text-align: left;\r\n}\r\n\r\n.info-icon {\r\n  font-size: 1.1rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Caja de aviso ── */\r\n.advice-box {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  background: #fffbf0;\r\n  border: 1px solid #f5e4a0;\r\n  border-radius: 10px;\r\n  padding: 14px 16px;\r\n  margin-top: 16px;\r\n  text-align: left;\r\n}\r\n\r\n.advice-icon {\r\n  font-size: 1.2rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.advice-box p {\r\n  font-size: 0.85rem;\r\n  color: #666;\r\n  margin: 0;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* ── Responsive ── */\r\n@media (max-width: 500px) {\r\n  .result-card { padding: 28px 20px; }\r\n  .title { font-size: 1.5rem; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
